module.exports = __webpack_public_path__ + "img/logo-white.364ca825.svg";